import { ClientValidationErrorKeys } from '@/components/Views/Company/File/Client/client-info-form.types';

export enum FileDetailErrorKeys {
    REF_NUMBER = 'ref_number',
    ADDRESS = 'address',
    COMPANY_ID = 'company_id',
    BRANCH_ID = 'branch_id',
    CLOSE_DATE = 'close_date',
    BALANCE_DUE = 'balance_due',
    NOTES = 'notes',
}

export const CLIENT_VALIDATION_ERROR_KEYS = [
    ClientValidationErrorKeys.EMAIL,
    ClientValidationErrorKeys.PHONE,
    ClientValidationErrorKeys.ROLE,
] as const satisfies ClientValidationErrorKeys[];

export const HANDLED_ERROR = 'handled_error';

export type ClientValidationErrorKey = (typeof CLIENT_VALIDATION_ERROR_KEYS)[number];

export type ClientLaravelErrorKey = `${ClientValidationErrorKey}.${number}`;

export type ClientLaravelErrorTuple = [ClientLaravelErrorKey, ErrorValueArray];

type ErrorKey = string | ClientLaravelErrorKey;

type ErrorValueArray = string[];

export type ServerErrors = Record<ErrorKey, ErrorValueArray>;

export interface ServerErrorResponse {
    errors?: ServerErrors;
    message?: string;
}
